import type { Asset } from "@overmap-ai/common"
import { memo, useMemo, useState } from "react"

import { SelectedAssetsContext } from "./context"

export const SelectedAssetProvider = memo((props) => {
	const [selectedAssetIds, setSelectedAssetIds] = useState<Asset["uuid"][]>([])

	const selectedAssetsContextValue = useMemo(
		() => ({
			selectedAssetIds,
			setSelectedAssetIds,
		}),
		[selectedAssetIds],
	)

	return <SelectedAssetsContext.Provider value={selectedAssetsContextValue} {...props} />
})

SelectedAssetProvider.displayName = "SelectedAssetProvider"
